import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	height: 100%;
`;

export const Panel = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	border-right: 1px solid #e5e7eb;

	&:last-child {
		border-right: none;
	}
`;

export const LeftPanel = styled(Panel)`
	width: 240px;
	flex-shrink: 0;
`;

export const MiddlePanel = styled(Panel)`
	width: 420px;
	flex-shrink: 0;
`;

export const RightPanel = styled(Panel)`
	flex: 1;
	min-width: 0;
`;

export const PanelHeader = styled.div`
	padding: 14px 16px;
	font-size: 13px;
	font-weight: 600;
	color: #1a1a1a;
	border-bottom: 1px solid #e5e7eb;
	flex-shrink: 0;
`;

export const PanelBody = styled.div`
	flex: 1;
	overflow-y: auto;
`;

// Request List styles
export const FilterBar = styled.div`
	display: flex;
	gap: 8px;
	padding: 8px 12px;
	border-bottom: 1px solid #e5e7eb;
`;

export const FilterInput = styled.input`
	flex: 1;
	background: #f9fafb;
	border: 1px solid #e5e7eb;
	border-radius: 6px;
	padding: 6px 10px;
	font-size: 13px;
	color: #1a1a1a;
	outline: none;

	&:focus {
		border-color: #3b82f6;
		box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}
`;

export const RequestCard = styled.div<{ $selected?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 12px 16px;
	border-left: 3px solid ${(p) => (p.$selected ? '#3b82f6' : 'transparent')};
	background: ${(p) => (p.$selected ? '#f0f5ff' : 'transparent')};

	&:hover {
		background: ${(p) => (p.$selected ? '#f0f5ff' : '#f9fafb')};
	}
`;

export const RequestDivider = styled.div`
	width: 80%;
	height: 1px;
	background: #e5e7eb;
	margin: 0 auto;
`;

export const MethodBadge = styled.span<{ $method: string }>`
	align-self: flex-start;
	font-size: 10px;
	font-weight: 700;
	padding: 2px 8px;
	border-radius: 4px;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	color: ${(p) => {
		switch (p.$method.toUpperCase()) {
			case 'POST':
				return '#2563eb';
			case 'GET':
				return '#16a34a';
			case 'PUT':
				return '#ca8a04';
			case 'DELETE':
				return '#dc2626';
			default:
				return '#4b5563';
		}
	}};
	background: ${(p) => {
		switch (p.$method.toUpperCase()) {
			case 'POST':
				return '#dbeafe';
			case 'GET':
				return '#dcfce7';
			case 'PUT':
				return '#fef9c3';
			case 'DELETE':
				return '#fee2e2';
			default:
				return '#f3f4f6';
		}
	}};
`;

export const RequestPath = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: #1a1a1a;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-top: 2px;
`;

export const RequestTime = styled.div`
	font-size: 11px;
	color: #9ca3af;
`;

// Log Tree styles
export const LogRow = styled.div<{ $selected?: boolean; $depth: number }>`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 16px;
	padding-left: ${(p) => 16 + p.$depth * 20}px;
	font-size: 13px;
	background: ${(p) => (p.$selected ? '#dbeafe' : 'transparent')};

	&:hover {
		background: ${(p) => (p.$selected ? '#dbeafe' : '#f9fafb')};
	}
`;

export const LogDot = styled.span<{ $category: 'turn' | 'generate' | 'tool' }>`
	width: 7px;
	height: 7px;
	border-radius: 50%;
	flex-shrink: 0;
	background: ${(p) => {
		switch (p.$category) {
			case 'turn':
				return '#22c55e';
			case 'generate':
				return '#3b82f6';
			case 'tool':
				return '#f59e0b';
		}
	}};
`;

export const LogLabel = styled.span`
	color: #1a1a1a;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const LogTime = styled.span`
	font-size: 12px;
	color: #9ca3af;
	margin-left: auto;
	flex-shrink: 0;
`;

// Detail panel styles
export const DetailContainer = styled.div`
	padding: 20px;
`;

export const DetailJson = styled.pre`
	font-family: 'SF Mono', 'Fira Code', 'Fira Mono', Menlo, Consolas, monospace;
	font-size: 13px;
	line-height: 1.6;
	color: #2563eb;
	white-space: pre-wrap;
	word-break: break-all;
	margin: 0;
`;

export const EmptyState = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	color: #9ca3af;
	font-size: 13px;
`;
